import { all, call, fork, put, takeLatest } from "@redux-saga/core/effects";
import { message } from "antd";
import {
  FETCH_AUDIT_LOGS_REQUEST,
  SEARCH_AUDIT_LOGS_REQUEST,
} from "redux/constants/AuditLogs";
import {
  fetchAuditLogsFailure,
  fetchAuditLogsSuccess,
  searchAuditLogsFailure,
  searchAuditLogsSuccess,
} from "redux/actions/AuditLogs";
import AuditLogs from "services/AuditLogs";

export function* onFetchAuditLogs() {
  yield takeLatest(FETCH_AUDIT_LOGS_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(
        AuditLogs.get,
        payload?.startDate,
        payload?.endDate
      );

      if (result?.success) {
        yield put(fetchAuditLogsSuccess(result.data ?? []));
      } else {
        message.error(result?.message || "Error fetching audit logs");
        yield put(fetchAuditLogsFailure(result?.message));
      }
    } catch (error) {
      message.error("Something went wrong");
      yield put(fetchAuditLogsFailure(error?.message));
    }
  });
}


export function* onSearchAuditLogs() {
  yield takeLatest(SEARCH_AUDIT_LOGS_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(
        AuditLogs.search,
        payload?.startDate,
        payload?.endDate,
        payload?.searchKeyword
      );
      if (result?.status) {
        yield put(searchAuditLogsSuccess(result.data || []));
      } else {
        message.error(result?.message || "Error searching audit logs");
        yield put(searchAuditLogsFailure(result?.message));
      }
    } catch (error) {
      message.error("something went wrong");
      yield put(searchAuditLogsFailure(error?.message));
    }
  });
}

export default function* rootSaga() {
  yield all([fork(onFetchAuditLogs), fork(onSearchAuditLogs)]);
}
